import React from "react";
// import Tooltip from "../Tooltip";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  ArcElement,
} from "chart.js";
import DoomsdayChart from "./DoomsdayChart";

// import { Line } from "react-chartjs-2-old";
// import Tooltip from "../../components/Tooltip";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  ArcElement,
);

ChartJS.defaults.set("plugins.datalabels", {
  display: false,
});

const constTempData = [
  // {
  //   key: "Doomsday Signal",
  //   description: "Summary Doomsday Signal",
  //   info: "An overall Doomsday Signal that is a weighted consolidated signal of the underlying twelve signals to identify the level of potential market risk.",
  // },
  {
    key: "Fear/Greed",
    description: "Longbow Fear/Greed Signal",
    info: "A Longbow Fear/Greed Signal that endeavors to gauge the emotion driving the current markets.",
  },
  {
    key: "Market Momentum",
    description: "S&P 500 vs its 125 DMA – Historical comparison",
    info: "A signal that tracks how far the S&P 500 is from its 125-day moving average over the past two years.",
  },
  {
    key: "Market Strength",
    description: "# stocks hitting 52W highs vs lows – Historical comparison",
    info: "A signal comparing the number of securities (stocks, ETFs, ADRs) hitting 52-week highs versus lows on US exchanges over the past year. Compares TRADHIGH and TRADLOW Indexes on Bloomberg.",
  },
  {
    key: "Market Breadth",
    description: "Volume of stocks trading up vs down – Historical comparison",
    info: "A signal that analyzes the volume of shares trading in securities on the rise versus those in decline in the US over the past year, per the McClellans Advances – Declines US Index via SUM INX Index on Bloomberg.",
  },
  {
    key: "Equity Put/Call Ratio",
    description: "Put/call ratio for US equities – Historical comparison",
    info: "A signal that compares the trading volume of bullish call options relative to that of bearish put options over the past two years, per the CBOE Equity Put/Call Ratio.",
  },
  {
    key: "Volatility",
    description: "S&P Volatility – Historical comparison",
    info: "An indicator that compares the S&P 500’s volatility over the past two years, per the VIX Index.",
  },
  {
    key: "Junk Bond Demand",
    description: "Spread between yields on HY and IG – Historical comparison",
    info: "A signal that analyzes the spread between junk bonds and investment grade bonds over the past 2 years.",
  },
  {
    key: "Safe Haven Demand",
    description: "Difference in returns for S&P vs TLT – Historical comparison",
    info: "A signal that looks at the difference in returns for US stocks versus US Treasuries over the past two years.",
  },
  {
    key: "Vol of Vol vs. Vol",
    description: "The ratio of the VVIX vs VIX – Historical comparison",
    info: "A signal that looks at the ratio of the VVIX Index to the VIX Index over the past two years.",
  },
  {
    key: "Global PMI",
    description:
      "Proprietary signal comparing global PMIs – Historical comparison",
    info: "A proprietary signal that identifies when there is greater or less risk, given trends in global PMI readings.",
  },
  {
    key: "Yield Inversion",
    description:
      "UST 10 Year Yields – UST 2 Year Yields – Historical comparison",
    info: "A signal that tracks the difference between the 10 Year and the 2 Year Treasury yields",
  },
  {
    key: "Volatility Thresholds",
    description: "Proprietary signal based on volatility metrics",
    info: "A propetiary signal that identifies when a broad number of market-related volatility measures point to greater or less market risk.",
  },
];

const displayBar = (row, signalStrength) => {
  const signalColor = (index) => {
    let primaryColor = "#ffffff";
    let halfColor = "linear-gradient(#3E3E3E 50%, #ffffff 50%)";
    let neutralColor = "#3E3E3E";

    if (row.flag === "Fear" || row.flag === "Extreme Fear") {
      primaryColor = "#75CE41";
      halfColor = "linear-gradient(#3E3E3E 50%, #75CE41 50%)";
      neutralColor = "#3E3E3E";
    }
    if (row.flag === "Greed" || row.flag === "Extreme Greed") {
      primaryColor = "#D33541";
      halfColor = "linear-gradient(#57262B 50%, #D33541 50%)";
      neutralColor = "#57262B";
    }
    const style = [
      [neutralColor, neutralColor, neutralColor, neutralColor, neutralColor],
      [halfColor, neutralColor, neutralColor, neutralColor, neutralColor],
      [primaryColor, neutralColor, neutralColor, neutralColor, neutralColor],
      [primaryColor, halfColor, neutralColor, neutralColor, neutralColor],
      [primaryColor, primaryColor, neutralColor, neutralColor, neutralColor],
      [primaryColor, primaryColor, halfColor, neutralColor, neutralColor],
      [primaryColor, primaryColor, primaryColor, neutralColor, neutralColor],
      [primaryColor, primaryColor, primaryColor, halfColor, neutralColor],
      [primaryColor, primaryColor, primaryColor, primaryColor, neutralColor],
      [primaryColor, primaryColor, primaryColor, primaryColor, halfColor],
      [primaryColor, primaryColor, primaryColor, primaryColor, primaryColor],
    ][isNaN(Math.round(signalStrength)) ? 0 : Math.round(signalStrength)];
    return style[index];
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-end",
        justifyContent: "space-around",
        width: 40,
      }}
    >
      <div
        style={{
          height: 10,
          width: 5,
          backgroundImage: signalColor(0).startsWith("l")
            ? signalColor(0)
            : "unset",
          backgroundColor: signalColor(0),
          borderRadius: 20,
        }}
      ></div>
      <div
        style={{
          height: 15,
          width: 5,
          backgroundImage: signalColor(1).startsWith("l")
            ? signalColor(1)
            : "unset",
          backgroundColor: signalColor(1),
          borderRadius: 20,
        }}
      ></div>
      <div
        style={{
          height: 20,
          width: 5,
          backgroundImage: signalColor(2).startsWith("l")
            ? signalColor(2)
            : "unset",
          backgroundColor: signalColor(2),
          borderRadius: 20,
        }}
      ></div>
      <div
        style={{
          height: 25,
          width: 5,
          backgroundImage: signalColor(3).startsWith("l")
            ? signalColor(3)
            : "unset",
          backgroundColor: signalColor(3),
          borderRadius: 20,
        }}
      ></div>
      <div
        style={{
          height: 30,
          width: 5,
          backgroundImage: signalColor(4).startsWith("l")
            ? signalColor(4)
            : "unset",
          backgroundColor: signalColor(4),
          borderRadius: 20,
        }}
      ></div>
    </div>
  );
};
export const DoomsdayDozenTable = (props) => {
  const data = [
    // {
    //   key: "Doomsday Signal",
    //   score: props.data?.DOOMSDAY_SCORE,
    //   flag: props.data?.DOOMSDAY_NAME,
    // },
    {
      key: "Fear/Greed",
      score: props.data?.FEAR_GREED_FINAL_SCORE,
      flag: props.data?.FEAR_GREED_NAME[0],
    },
    {
      key: "Market Momentum",
      score: props.data?.STK_PX_MOMO_SCORE,
      flag: props.data?.STK_PX_MOMO_NAME[0],
    },
    {
      key: "Market Strength",
      score: props.data?.STK_PX_STRNGTH_SCORE,
      flag: props.data?.STK_PX_STRNGTH_NAME[0],
    },
    {
      key: "Market Breadth",
      score: props.data?.STK_PX_BREADTH_SCORE,
      flag: props.data?.STK_PX_BREADTH_NAME[0],
    },
    {
      key: "Equity Put/Call Ratio",
      score: props.data?.PUT_CALL_SCORE,
      flag: props.data?.PUT_CALL_NAME[0],
    },
    {
      key: "Volatility",
      score: props.data?.VOL_SCORE,
      flag: props.data?.VOL_NAME[0],
    },
    {
      key: "Junk Bond Demand",
      score: props.data?.JUNK_SCORE,
      flag: props.data?.JUNK_NAME[0],
    },
    {
      key: "Safe Haven Demand",
      score: props.data?.SAFE_SCORE,
      flag: props.data?.SAFE_NAME[0],
    },
    {
      key: "Vol of Vol vs. Vol",
      score: props.data?.VVIX_SCORE,
      flag: props.data?.VVIX_NAME[0],
    },
    {
      key: "Global PMI",
      score: props.data?.PMI_SCORE,
      flag: props.data?.PMI_NAME[0],
    },
    {
      key: "Yield Inversion",
      score: props.data?.INVERSION_SCORE,
      flag: props.data?.INVERSION_NAME[0],
    },
    {
      key: "Volatility Thresholds",
      score: props.data?.VOLTHRESH_SCORE,
      flag: props.data?.VOLTHRESH_NAME[0],
    },
  ];
  return constTempData.map((row, i) => {
    let signalStrength = 0;
    if (data[i]?.hasOwnProperty("score")) {
      if (
        data[i].key === "Global PMI" ||
        data[i].key === "Yield Inversion" ||
        data[i].key === "Volatility Thresholds"
      ) {
        signalStrength = Math.abs(data[i].score) / 10;
      } else {
        signalStrength = Math.abs(data[i].score - 50) / 5;
      }
    }
    return (
      <div className="asset-info-row" label={row.key} key={i + row.key}>
        <div className="cell-first" style={{ paddingLeft: 20 }}>
          {row.key}
          <div
            data-tip={row.info}
            className="info-icon"
            style={{
              marginLeft: 5,
              marginBottom: 2,
            }}
          >
            i
          </div>
        </div>
        <div className="cell-first" style={{ paddingLeft: 20 }}>
          {/* SCORE */}
          {displayBar(data[i], signalStrength)}
        </div>
        <div className="cell-first" style={{ paddingLeft: 20 }}>
          {/* SIGNAL STRENGTH */}
          {Math.round(signalStrength * 100) / 100}
        </div>
        <div
          style={{
            paddingRight: 40,
            marginRight: 20,
            color: nameToColor(data[i].flag),
          }}
          className={`cell-first`}
        >
          {/* FLAG*/}
          {data[i].flag}
        </div>
        <div className={`cell-first description`}>{row.description}</div>
        {/* <div className='asset-info-row' style={{margin}}></div> */}
      </div>
    );
  });
};

function getGradient(ctx, chartArea) {
  const colors = [];
  const xMid = (chartArea.left + chartArea.right) / 2;
  const yMid = chartArea.bottom;
  const gradientOne = ctx.createConicGradient(Math.PI, xMid, yMid);
  gradientOne.addColorStop(0, "#75CE41");
  gradientOne.addColorStop(0.125, "#4A8556");
  gradientOne.addColorStop(0.25, "#757575");
  gradientOne.addColorStop(0.375, "#FF5349");
  gradientOne.addColorStop(0.5, "#8B0000");
  colors.push(gradientOne);
  colors.push(gradientOne);
  colors.push(gradientOne);
  colors.push(gradientOne);
  return colors;
}

// function drawText(ctx, chartArea, radius, txt) {
//   // Get options from the center object in options
//   var fontStyle = "capsule";
//   var color = "#FFF";
//   var maxFontSize = 75;
//   var sidePadding = 20;
//   var sidePaddingCalculated = (sidePadding / 100) * (radius * 2);
//   // Start with a base font of 30px
//   ctx.font = "30px " + fontStyle;

//   // Get the width of the string and also the width of the element minus 10 to give it 5px side padding
//   var stringWidth = ctx.measureText(txt).width;
//   var elementWidth = radius * 2 - sidePaddingCalculated;

//   // Find out how much the font can grow in width.
//   var widthRatio = elementWidth / stringWidth;
//   var newFontSize = Math.floor(30 * widthRatio);
//   var elementHeight = radius * 2;

//   // Pick a new font size so it will not be larger than the height of label.
//   var fontSizeToUse = Math.min(newFontSize, elementHeight, maxFontSize);
//   var minFontSize = 20;
//   var lineHeight = 25;
//   var wrapText = false;

//   if (minFontSize === undefined) {
//     minFontSize = 20;
//   }

//   if (minFontSize && fontSizeToUse < minFontSize) {
//     fontSizeToUse = minFontSize;
//     wrapText = true;
//   }

//   // Set font settings to draw it correctly.
//   ctx.textAlign = "center";
//   ctx.textBaseline = "middle";
//   var centerX = (chartArea.left + chartArea.right) / 2;
//   var centerY = (chartArea.top + chartArea.bottom) / 2;
//   ctx.font = fontSizeToUse + "px " + fontStyle;
//   ctx.fillStyle = color;

//   if (!wrapText) {
//     ctx.fillText(txt, centerX, centerY);
//     return;
//   }

//   var words = txt.split(" ");
//   var line = "";
//   var lines = [];

//   // Break words up into multiple lines if necessary
//   for (var n = 0; n < words.length; n++) {
//     var testLine = line + words[n] + " ";
//     var metrics = ctx.measureText(testLine);
//     var testWidth = metrics.width;
//     if (testWidth > elementWidth && n > 0) {
//       lines.push(line);
//       line = words[n] + " ";
//     } else {
//       line = testLine;
//     }
//   }

//   // Move the center up depending on line height and number of lines
//   centerY -= (lines.length / 2) * lineHeight;

//   for (var n = 0; n < lines.length; n++) {
//     ctx.fillText(lines[n], centerX, centerY);
//     centerY += lineHeight;
//   }
//   //Draw text in center
//   ctx.fillText(line, centerX, centerY);
// }

function drawNeedle(ctx, chartArea, radius, ddScore) {
  var radianAngle = (ddScore / 100) * Math.PI;
  var cw = chartArea.right - chartArea.left;
  var ch = chartArea.bottom - chartArea.top;
  var cx = cw / 2;
  var cy = ch - ch / 4;

  // Draw Needle
  ctx.translate(cx, cy);
  ctx.rotate(radianAngle);
  ctx.beginPath();
  ctx.moveTo(0, -5);
  ctx.lineTo(-radius * 1.55, 0);
  ctx.lineTo(0, 5);
  ctx.fillStyle = "ghostwhite";
  ctx.fill();
  ctx.rotate(-radianAngle);
  ctx.translate(-cx, -cy);
  ctx.beginPath();
  ctx.arc(cx, cy, 7, 0, 360);
  ctx.fill();

  // Get overall Doomsday Score
  ctx.fillStyle = nameToColor(numberToName(ddScore));
  ctx.beginPath();
  ctx.ellipse(cx, ch * 0.8, radius / 4, radius / 4, 0, 0, 2 * Math.PI);
  ctx.fill();

  ctx.font = "50px capsule";
  ctx.fillStyle = "rgb(255, 255, 255)";
  ctx.fillText(Math.round(ddScore), cx, ch * 0.8 + 18);

  // Annotations for 0, 50, 100, Extreme Fear/Greed
  ctx.save();
  ctx.font = "16px capsule";
  ctx.textAlign = "center";
  ctx.fillStyle = "#75CE41";
  ctx.fillText("Extreme Fear", 52, cy + 30);
  ctx.fillStyle = "#fff";
  ctx.fillText("Be opportunistic", 65, cy + 50);
  ctx.fillStyle = "rgb(255, 255, 255)";
  ctx.fillText(0, 40, cy);
  ctx.fillText(50, cx, cy - 205);
  ctx.fillText(100, 460, cy);
  ctx.fillStyle = "#ff2222";
  ctx.fillText("Extreme Greed", 440, cy + 30);
  ctx.fillStyle = "#fff";
  ctx.fillText("Be Cautious", 449, cy + 50);
  ctx.fillText(
    "Buy when others are fearful and sell when others are complacent",
    250,
    cy + 85,
  );
}

//Check later
const numberToName = (number) => {
  if (number <= 20) {
    return "Extreme Fear";
  } else if (number <= 40) {
    return "Fear";
  } else if (number <= 60) {
    return "Neutral";
  } else if (number <= 80) {
    return "Greed";
  }
  return "Extreme Greed";
};

const nameToColor = (name) => {
  switch (name) {
    case "Extreme Fear":
      return "#75CE41";
    case "Fear":
      return "#4a8556";
    case "Extreme Greed":
      return "#ff2222";
    case "Greed":
      return "#ff6666";
    case "Neutral":
    default:
      return "#757575";
  }
};

export default function DoomsdayTable(props) {
  const [, updateState] = React.useState();
  const [ddScore, updateDDScore] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);

  React.useEffect(() => {
    (props && !props.reload) || (!props.data?.FEAR_GREED_NAME && forceUpdate());
  }, [props, forceUpdate]);

  React.useEffect(() => {
    if (props.data?.DOOMSDAY_SCORE) {
      updateDDScore(
        props.data.DOOMSDAY_SCORE[props.data.DOOMSDAY_SCORE.length - 1],
      );
    } else {
      updateDDScore(0);
    }
  }, [props.data?.DOOMSDAY_SCORE]);
  // <Tooltip />;

  return (
    <section className="section sector-performance">
      <div className="table-div">
        <div className="sector-performance-content">
          <div className="sector-doomsday-score-content">
            {props.data && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  height: 380,
                }}
              >
                <div
                  style={{ width: 500, marginTop: -100, pointerEvents: "none" }}
                >
                  <Doughnut
                    data={{
                      datasets: [
                        {
                          backgroundColor: function (context) {
                            const chart = context.chart;
                            const { ctx, chartArea } = chart;
                            if (!chartArea) {
                              // This case happens on initial chart load
                              return null;
                            }
                            return getGradient(ctx, chartArea);
                          },
                          data: [25, 25, 25, 25],
                        },
                      ],
                    }}
                    options={{
                      animation: {
                        onProgress: function (context) {
                          const chart = context.chart;
                          const { ctx, chartArea } = chart;
                          drawNeedle(
                            ctx,
                            chartArea,
                            150, //parametrize
                            ddScore,
                          );
                        },
                      },
                      rotation: -90, // start angle in degrees
                      circumference: 180, // sweep angle in radians
                      cutout: "95%",
                      plugins: {
                        // gaugeChart: {
                        //   needle: function(chart, args, options) {
                        //     const chart = context.chart;
                        //     const { ctx, chartArea } = chart;
                        //     drawNeedle(
                        //       ctx,
                        //       chartArea,
                        //       150, //parametrize
                        //       ddScore,
                        //     );
                        //   }
                        // },
                        tooltip: {
                          enabled: false,
                          //   mode: "index",
                          //   intersect: false,
                          callbacks: {
                            label: function () {
                              return "";
                            },
                          },
                        },
                      },
                    }}
                    style={{
                      // borderWidth: 1,
                      // height: 10,
                      // width: "10vw",
                      hoverColor: "",
                    }}
                  />
                </div>
                <div style={{ marginTop: 30 }}>
                  <DoomsdayChart
                    key={"DOOMSDAY_SCORE"}
                    title={"OVERALL DOOMSDAY SIGNAL HISTORY"}
                    info={`The historical score of the 12 weighted underlying signals related to the level of potential market risk.
                    Extreme greed signals market participants are being complacent therefore investors  should be cautious going long.
                    Extreme fear signals market participants are being fearful therefore investors should be opportunistic going long.
                    `}
                    dates={props.data?.DATE} //ascending order
                    values={props.data?.DOOMSDAY_SCORE} //ascending order
                    indexes={[]}
                    labelsExist={true}
                    labelsReverse={false}
                    yAxis={"TOTAL SCORE"}
                    fullScreen={false} //CHANGE LATER!
                    showGradient={true}
                    signal={props.data}
                  />
                </div>
              </div>
            )}
            {/* <div className="doomsday-score-table">
              <div className={`dd-asset-info-row`}>
                <div className={`cell-second`}>Period</div>
                <div
                  style={{
                    paddingRight: 20,
                    marginRight: 20,
                  }}
                  className={`cell-second`}
                >
                  Flag
                </div>
                <div className={`cell-second`}>Score</div>
              </div>
              {props.reload === false && props.data?.FEAR_GREED_NAME && (
                <DoomsdayScoreTable data={props.data} reload={props.reload} />
              )}
            </div> */}
          </div>
          <div className="asset-info-row">
            <div
              className="cell-first"
              style={{ color: "#bbb8b8", paddingLeft: 20 }}
            >
              Signal Name
            </div>
            <div
              className="cell-first"
              style={{ color: "#bbb8b8", paddingLeft: 20 }}
            >
              Signal Strength
            </div>
            <div
              className="cell-first"
              style={{ color: "#bbb8b8", paddingLeft: 20 }}
            >
              Score
              <div style={{ flex: "column" }}>(out of 10)</div>
            </div>
            <div className="cell-first" style={{ color: "#bbb8b8" }}>
              Flag
            </div>
            <div className="cell-first" style={{ color: "#bbb8b8" }}>
              Brief Description
            </div>
          </div>
        </div>
        <div className="sector-performance-content">
          {props.reload === false && props.data?.FEAR_GREED_NAME && (
            <DoomsdayDozenTable data={props.data} reload={props.reload} />
          )}
        </div>
      </div>
    </section>
  );
}
